import {
  DateType,
  DynamicPropertiesFilter,
  EmcSearchOutput,
  PageInfo,
  SelectableItem,
} from './dynamic-buildings.model';
import { UserType } from './customer.model';

export const POLE_USER_TYPES = [
  { value: UserType.FirstCapturedUser, translation: 'COMMON.USER.TYPE.FIRST_CAPTURED' },
  { value: UserType.LastCapturedUser, translation: 'COMMON.USER.TYPE.LAST_CAPTURED' },
  { value: UserType.ReassignedBy, translation: 'COMMON.USER.TYPE.REASSIGNED' },
  { value: UserType.ValidatedBy, translation: 'COMMON.USER.TYPE.VALIDATED' },
  { value: UserType.AuditedBy, translation: 'COMMON.USER.TYPE.AUDITED' },
  { value: UserType.ReviewedBy, translation: 'INSTALLATIONS.DETAILS.REVIEWED_BY' },
];

export const POLE_VALIDATION_STATUSES = [
  { value: 1, translation: 'COMMON.ASSET_STATUS.PENDING' },
  { value: 2, translation: 'COMMON.ASSET_STATUS.COMPLETE' },
  { value: 4, translation: 'COMMON.ASSET_STATUS.ASSIGNED' },
  { value: 5, translation: 'COMMON.ASSET_STATUS.REJECTED' },
  { value: 6, translation: 'COMMON.ASSET_STATUS.RETAGGED' },
];

export const POLE_CONDITIONS = [
  { value: 1, translation: 'COMMON.POLE.CONDITION.GOOD' },
  { value: 2, translation: 'COMMON.POLE.CONDITION.BENT' },
  { value: 3, translation: 'COMMON.POLE.CONDITION.VANDALIZED' },
];

// Property names match backend PoleFilter; the trailing block is UI state only
export class PoleStaticFilter {
  sortBy: number = 1;
  search: string = '';
  filterBy: string = '';
  dateFrom: string | null = null;
  dateTo: string | null = null;
  dateType: DateType = DateType.LastUpdateTime;
  userType: number | null = null;
  type: number = 0;
  condition: number = 0;
  reviewStatus: boolean | null = null;
  validationStatuses: number[] = [];
  selectedAreas: number[] = [];
  selectedRegions: number[] = [];
  selectedSubGeographicalRegions: number[] = [];
  selectedGeographicalRegions: number[] = [];
  selectedUsers: number[] = [];
  dtId: number | null = null;
  dtIds: number[] = [];

  dateTypeString: string = 'Last Update Time';
  regionSearchText: string = '';
  areaSearchText: string = '';
  geoSearchText: string = '';
  subGeoSearchText: string = '';
  searchUsersText: string = '';
  selectedRegionModel: SelectableItem | null = null;
  selectedGeoRegionModel: SelectableItem | null = null;
  selectedAreaModels: SelectableItem[] = [];
  selectedSubGeoModels: SelectableItem[] = [];
  selectedUserModels: SelectableItem[] = [];
  dtName: string = '';
}

export class DynamicPoleFilter {
  pageInfo: PageInfo = new PageInfo();
  filterParams: PoleStaticFilter = new PoleStaticFilter();
  dynamicFilters: DynamicPropertiesFilter[] = [];
  searchObject: EmcSearchOutput = new EmcSearchOutput();
}
